import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';

/**
 * @slot - contents placed within the item
 * @slot icon - optional icon
 */
@Component({
  tag: 'wb-header-tool-list-item',
  styleUrl: 'header-tool-list-item.scss',
  shadow: true,
})
export class HeaderToolListItemComponent implements ComponentInterface {
  /** renders an anchor tag linked to the passed in URL */
  @Prop()
  public href: string;

  /** can be used in combination with `href` property */
  @Prop()
  public download?: string;

  /** can be used in combination with `href` property */
  @Prop()
  public rel?: string;

  /** can be used in combination with `href` property */
  @Prop()
  public target?: string;

  private TagNames = transformTagNames(this, 'wb-header-tool-list-item', ['wb-text']);

  public render(): JSX.Element {
    const { WbText } = this.TagNames;

    return (
      <Host class="wb-header-tool-list-item">
        <WbText size="l">
          <a class="anchor" href={this.href} target={this.target} rel={this.rel} download={this.download}>
            <slot name="icon" />
            <slot />
          </a>
        </WbText>
      </Host>
    );
  }
}
